import { gql } from '@apollo/client';

import STUDENT_FRAGMENT from '../fragments/student';

export default gql`
  mutation removeStudentMutation($where: StudentWhereInput!) {
    removeStudent(where: $where) {
      ...BaseStudent
    }
  }
  ${STUDENT_FRAGMENT}
`;
